import React from 'react';

export function GoPalLogo({ size = 26 }: { size?: number }) {
  const box = Math.round(size * 1.85);
  return (
    <div
      style={{
        width: box, height: box,
        background: 'var(--accent)',
        borderRadius: 'var(--r-lg)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        margin: '0 auto 14px',
        boxShadow: '0 2px 8px rgba(22,163,74,.4)',
      }}
    >
      <svg viewBox="0 0 96 96" style={{ width: size, height: size }} fill="none">
        <rect x="24" y="28" width="48" height="56" rx="8" fill="rgba(255,255,255,0.16)" />
        <rect x="38" y="28" width="20" height="9" fill="#16A34A" />
        <rect x="38" y="18" width="20" height="19" rx="5" fill="rgba(255,255,255,0.92)" />
        <rect x="31" y="44" width="34" height="3" rx="1.5" fill="rgba(255,255,255,0.4)" />
        <rect x="31" y="52" width="22" height="3" rx="1.5" fill="rgba(255,255,255,0.4)" />
        <path d="M31 69 L61 69" stroke="white" strokeWidth="3.5" strokeLinecap="round" />
        <path d="M53 63 L61 69 L53 75" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>
    </div>
  );
}

export function AuthShell({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="flex items-center justify-center"
      style={{ height: '100vh', background: 'var(--bg)', fontFamily: 'var(--font)' }}
    >
      <div
        style={{
          width: 420, padding: 'var(--sp-8)',
          background: 'var(--surface)',
          borderRadius: 'var(--r-xl)',
          boxShadow: 'var(--shadow-lg)',
          border: '1px solid var(--border)',
        }}
      >
        {children}
      </div>
    </div>
  );
}
